enum FullEarlyRepaymentMethods {
    PROPERTY_SALE = 'PROPERTY_SALE',
    REMORTGAGE_OR_FURTHER_ADVANCE = 'REMORTGAGE_OR_FURTHER_ADVANCE',
    INCOME_OR_BONUS = 'INCOME_OR_BONUS',
    SAVINGS = 'SAVINGS',
    PENSION_LUMP_SUM = 'PENSION_LUMP_SUM',
    INHERITANCE = 'INHERITANCE',
    OTHER = 'OTHER',
}

export const repaymentMethodConfig = [
    {
        label: 'Property sale',
        value: 'Property sale',
        enumValue: FullEarlyRepaymentMethods.PROPERTY_SALE,
    },
    {
        label: 'Remortgage / further advance',
        value: 'Remortgage / further advance',
        enumValue: FullEarlyRepaymentMethods.REMORTGAGE_OR_FURTHER_ADVANCE,
    },
    {
        label: 'Income / bonus',
        value: 'Income / bonus',
        enumValue: FullEarlyRepaymentMethods.INCOME_OR_BONUS,
    },
    {
        label: 'Savings',
        value: 'Savings',
        enumValue: FullEarlyRepaymentMethods.SAVINGS,
    },
    {
        label: 'Pension lump sum',
        value: 'Pension lump sum',
        enumValue: FullEarlyRepaymentMethods.PENSION_LUMP_SUM,
    },
    {
        label: 'Inheritance',
        value: 'Inheritance',
        enumValue: FullEarlyRepaymentMethods.INHERITANCE,
    },
    {
        label: 'Other',
        value: 'Other',
        enumValue: FullEarlyRepaymentMethods.OTHER,
    },
];
